export var UserRole;
(function (UserRole) {
    UserRole["admin"] = "admin";
    UserRole["userMail"] = "userMail";
    UserRole["userToken"] = "userToken";
    UserRole["guest"] = "guest";
})(UserRole || (UserRole = {}));
//# sourceMappingURL=userRole.js.map